import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, AfterViewInit} from '@angular/core';
import {HorizontalSliderComponent} from '../horizontal-slider/horizontal-slider.component';
import {Card, CardsArray} from '../../../model/cards';

@Component({
  selector: 'app-hotel-gallery',
  imports: [
    HorizontalSliderComponent
  ],
  templateUrl: './hotel-gallery.component.html',
  standalone: true,
  styleUrl: './hotel-gallery.component.scss'
})
export class HotelGalleryComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() cards: Card[] = CardsArray;
  @Input() startIndex: number = 0;
  @Input() cardsLength: boolean = false;
  @Input() firstArray: boolean = true;
  @Output() clickOn = new EventEmitter();
  @Output() sliderEndReached = new EventEmitter<void>();
  @Output() sliderComponentReady = new EventEmitter<any>();

  @ViewChild(HorizontalSliderComponent) horizontalSlider!: HorizontalSliderComponent;

  grid: number = 3;
  cardsArray: Card[] = [];

  ngOnInit() {
    this.cardsArray = this.cards.map((card, index) => {
      return { ...card, originalIndex: this.startIndex + index };
    });

    if (window.innerWidth < 769) {
      this.grid = 2;
    }
    if (window.innerWidth < 576) {
      this.grid = 1;
    }
  }

  ngAfterViewInit() {
    if (this.horizontalSlider) {
      this.sliderComponentReady.emit(this.horizontalSlider);
    }
  }

  getCards() {
    return this.cardsArray;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cards']) {
      this.cardsArray = this.cards.map((card, index) => {
        return { ...card, originalIndex: this.startIndex + index };
      });
    }
    if (changes['startIndex']) {
      this.cardsArray = this.cards.map((card, index) => {
        return { ...card, originalIndex: this.startIndex + index };
      });
    }
  }

  emitClick(bool: boolean) {
    this.clickOn.emit(bool);
  }

  onPositionChanged(event: { isAtStart: boolean; isAtEnd: boolean }) {
    if (event.isAtEnd) {
      this.sliderEndReached.emit();
    }
  }

  protected readonly CardsArray = CardsArray;
}
